export default __webpack_public_path__ + "274dc3959a972d91900a00e0071c6b06.ogg";